import React, { useState } from 'react';
import './ContactCard.css';
import NowPlayingModal, { SpotifyWaves } from './NowPlayingModal';

const LINKS = {
  twitter: 'https://twitter.com/Quinnscodes',
  github: 'https://github.com/quinnlicious',
  linkedin: 'https://www.linkedin.com/in/akquinn/',
};

const HERO_PHOTO = `${process.env.PUBLIC_URL}/images/quinn-hero.webp`;
const photoStyle = { backgroundImage: `url(${HERO_PHOTO})` };

const ActionButton = ({ href, label, children }) => (
  <a
    className="ios-action"
    href={href}
    aria-label={label}
    target={href.startsWith('mailto:') ? undefined : '_blank'}
    rel="noopener noreferrer"
  >
    <span className="ios-action-icon">{children}</span>
  </a>
);

const ContactCard = () => {
  const [npOpen, setNpOpen] = useState(false);
  return (
    <div className="ios-contact">
      {/* Hero: photo at the top with status/nav chrome + name overlaid */}
      <div className="ios-hero">
        <img className="ios-hero-photo" src={HERO_PHOTO} alt="" />
        <div className="ios-hero-fade" />
        <div className="ios-dynamic-island" aria-hidden="true" />

        {/* Status bar */}
        <div className="ios-statusbar">
          <span className="ios-time">15:38</span>
          <span className="ios-status-icons">
            <svg className="ios-bars" viewBox="0 0 18 12" aria-hidden="true">
              <rect x="0" y="8" width="3" height="4" rx="1" />
              <rect x="5" y="5" width="3" height="7" rx="1" />
              <rect x="10" y="2.5" width="3" height="9.5" rx="1" />
              <rect x="15" y="0" width="3" height="12" rx="1" />
            </svg>
            <svg className="ios-wifi" viewBox="0 0 18 14" aria-hidden="true">
              <path d="M9 13.2 11 11a2.8 2.8 0 0 0-4 0l2 2.2Z" />
              <path d="M9 8.6c1.5 0 2.9.6 4 1.6l1.4-1.5A8 8 0 0 0 9 6.4a8 8 0 0 0-5.4 2.3L5 10.2A5.8 5.8 0 0 1 9 8.6Z" />
              <path d="M9 3.9c2.7 0 5.2 1 7.1 2.8L17.5 5.2A11.3 11.3 0 0 0 9 1.6 11.3 11.3 0 0 0 .5 5.2L1.9 6.7A10.2 10.2 0 0 1 9 3.9Z" />
            </svg>
            <svg className="ios-battery" viewBox="0 0 26 13" aria-hidden="true">
              <rect x="0.5" y="0.5" width="22" height="12" rx="3" fill="none" stroke="currentColor" opacity="0.5" />
              <rect x="2" y="2" width="18" height="9" rx="1.5" />
              <rect x="23.5" y="4" width="1.8" height="5" rx="0.9" opacity="0.5" />
            </svg>
          </span>
        </div>

        {/* Nav bar */}
        <div className="ios-navbar">
          <span className="ios-back" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
          <span className="ios-edit">Edit</span>
        </div>

        <h1 className="ios-name">dr quinn</h1>
      </div>

      {/* Action buttons (dark circles below the photo) */}
      <div className="ios-actions">
        <ActionButton href={LINKS.twitter} label="Message me on X / Twitter">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3C6.5 3 2 6.4 2 10.6c0 2 1 3.8 2.6 5.2-.1 1.1-.6 2.2-1.3 3-.2.3 0 .7.4.6 1.7-.3 3-1 3.9-1.6 1.3.4 2.7.6 4.4.6 5.5 0 10-3.4 10-7.8S17.5 3 12 3Z" /></svg>
        </ActionButton>
        <ActionButton href={LINKS.github} label="GitHub profile">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.6.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.5.6 3.6.1.4 0 .8-.3 1l-2.2 2.2Z" /></svg>
        </ActionButton>
        <ActionButton href={LINKS.linkedin} label="LinkedIn profile">
          <svg viewBox="0 0 24 24" fill="currentColor"><path d="M17 10.5V7c0-.6-.4-1-1-1H4c-.6 0-1 .4-1 1v10c0 .6.4 1 1 1h12c.6 0 1-.4 1-1v-3.5l4 4v-11l-4 4Z" /></svg>
        </ActionButton>
        <button
          type="button"
          className="ios-action ios-action-spotify"
          onClick={() => setNpOpen(true)}
          aria-label="What I'm listening to"
        >
          <span className="ios-action-icon"><SpotifyWaves /></span>
        </button>
      </div>

      {/* Contact Photo & Poster row */}
      <div className="ios-poster-row">
        <span className="ios-poster-thumb" style={photoStyle} />
        <span className="ios-poster-label">Contact Photo &amp; Poster</span>
        <span className="ios-chevron" aria-hidden="true">
          <svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
        </span>
      </div>

      {/* Info panel */}
      <div className="ios-info-card">
        <div className="ios-info-row">
          <div className="ios-info-text">
            <span className="ios-info-label">education</span>
            <span className="ios-info-value">PhD in VR in Education</span>
          </div>
        </div>
        <div className="ios-info-row">
          <div className="ios-info-text">
            <span className="ios-info-label">education</span>
            <span className="ios-info-value">BSc in Computer Science</span>
          </div>
        </div>
        <a className="ios-info-row ios-info-link" href={LINKS.linkedin} target="_blank" rel="noopener noreferrer">
          <div className="ios-info-text">
            <span className="ios-info-label">other</span>
            <span className="ios-info-value">linkedin.com/in/akquinn</span>
          </div>
          <span className="ios-info-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
          </span>
        </a>
      </div>

      {/* Notes */}
      <div className="ios-info-card">
        <div className="ios-notes">
          <span className="ios-info-label">Notes</span>
          <p>Software Developer at Ionology, focused on AI integration &amp; development. Freelance VR developer.</p>
        </div>
      </div>

      {/* iOS home indicator */}
      <div className="ios-home-indicator" aria-hidden="true" />

      <NowPlayingModal open={npOpen} onClose={() => setNpOpen(false)} />
    </div>
  );
};

export default ContactCard;
